<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div class="container py-3">
      <div class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center">
        <a href="https://www.chanchao.com.tw/th/">
          <div class="d-flex align-items-center">
            <img src="../../assets/images/ChanChaoLogo.png" class="navLogo mt-2" />
            <div class="mx-2 logoText text-dark font-weight-nomal">
              <div>สมาชิกจ่านจาว</div>
            </div>
          </div>
        </a>

        <div class="d-flex ml-1">
          <a href="https://www.chanchao.com.tw/accounts/login">
            <img src="../../assets/images/langTW.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
            <span class="navEnText text-muted mr-3"> 中文版 </span>
          </a>

          <a href="https://www.chanchao.com.tw/accounts/en/login">
            <img src="../../assets/images/lang.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
            <span class="navEnText text-muted mr-3"> English </span>
          </a>

          <a href="https://www.chanchao.com.tw/accounts/vn/login">
            <img src="../../assets/images/vn.svg" style="width: 17px; height: 17px" class="mb-1" />
            <span class="navEnText text-muted ml-1"> Tiếng Việt </span>
          </a>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 mt-4 mb-md-4 mb-0 px-4">
          <div class="d-flex align-items-center mb-4">
            <img src="../../assets/images/loginIcon.png" class="mr-2 mb-2" style="width: 40px; height: 40px" alt="" />
            <h4>ออกจากระบบ</h4>
          </div>
          <form>
            <div class="form-group h6">
              <label for="loginEmail">ที่อยู่อีเมล</label>
              <input
                type="email"
                class="form-control"
                id="loginEmail"
                aria-describedby="emailHelp"
                name="email"
                maxlength="50"
                v-model="email"
                ref="loginEmail"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
              />
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('email')"
                >{{ errors.first('email') }}
              </span>
            </div>
            <div class="form-group h6">
              <label for="loginPassword">รหัสผ่าน</label>
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  class="form-control"
                  id="loginPassword"
                  name="password"
                  autocomplete="off"
                  maxlength="20"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  v-model="password"
                  ref="loginPassword"
                />

                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('password')"
                >ช่องรหัสผ่านเว้นว่างไม่ได้
              </span>
            </div>
            <div class="form-group h6">
              <label for="loginPassword2">รหัสยืนยัน</label>
              <div class="d-flex justify-content-around align-items-center">
                <input
                  type="text"
                  class="form-control mr-1"
                  id="loginPassword2"
                  name="text"
                  maxlength="5"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  v-model="Validcode"
                  ref="loginPassword2"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('text')"
                >ช่องรหัสยืนยันเว้นว่างไม่ได้
              </span>
            </div>

            <div class="text-muted" style="font-size: 14px">
              <a href="https://www.chanchao.com.tw/en/otherMember.asp" target="_blank">
                การเข้าสู่ระบบจะถือว่าคุณได้ยินยอมเงื่อนไขในการให้บริการของเรา</a
              >
            </div>

            <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="loginBtn">ออกจากระบบ</button>
          </form>

          <hr />
          <p>พบปัญหาในการเข้าสู่ระบบ?</p>
          <div class="linkFrame">
            <a href="https://www.chanchao.com.tw/accounts/th/forgetPw">ลืมรหัสผ่าน</a>
            /

            <span class="MbDevice_inline">
              <router-link to="/th/signup">ลงทะเบียนทันที</router-link>
            </span>
            <span class="MbDevice_inline"> / </span>

            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank"> ติดต่อบริการลูกค้า</a>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <QAth />
        </div>
      </div>
    </div>

    <Footer />

    <router-view></router-view>
  </div>
</template>

<script>
  import QAth from '@/components/QA_th.vue'
  import Footer from '@/components/footer_en.vue'
  import $ from 'jquery'

  export default {
    metaInfo: {
      title: 'ออกจากระบบ - Chan Chao Exhibition Hall',
    },
    components: {
      QAth,
      Footer,
    },

    data() {
      return {
        getsrc: '',
        isLoading: false,
        typePwd: 'password',

        email: '',
        password: '',
        Validcode: '',

        CSRF_Token: '',
        alertTitle: '',
        alertText: '',
        access_token: '',
        lastUrl: '',
      }
    },

    watch: {
      Validcode: function () {
        const vm = this
        vm.$refs.loginPassword2.style.borderColor = '#ced4da'
      },

      email: function () {
        const vm = this
        vm.$refs.loginEmail.style.borderColor = '#ced4da'
      },

      password: function () {
        const vm = this
        vm.$refs.loginPassword.style.borderColor = '#ced4da'
      },
    },

    methods: {
      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },

      loginBtn() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin2/Login'
        const info = {
          login: vm.email,
          password: vm.password,
          Validcode: vm.Validcode,
          CSRF: vm.CSRF_Token,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, info).then(function (response) {
              if (response.data == '200') {
                if (vm.lastUrl) {
                  window.location.replace(vm.lastUrl)
                } else {
                  window.location.replace('https://www.chanchao.com.tw/th') //不會發生
                }
              } else if (response.data == '252') {
                vm.alertText = 'คุณใส่ที่อยู่อีเมลผิดพลาด'
                vm.alertError()
                vm.$refs.loginEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = 'คุณใส่รหัสผ่านผิดพลาด'
                vm.alertError()
                vm.$refs.loginPassword.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = 'รหัสยืนยันผิดพลาด โปรดใส่ใหม่'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else if (response.data == '258') {
                vm.alertText = 'เปิดใช้ cookie ของคุณในบราวเซอร์แล้วเข้าสู่ระบบอีกครั้ง'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else {
                vm.alertText = 'ระบบไม่ว่าง โปรดเข้าสู่ระบบภายหลัง'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'ช่องใส่ข้อมูลไม่ครบถ้วน โปรดตรวจสอบอีกครั้ง'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },
    },

    created() {
      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //GET LANDING PAGE

      let lastPage = document.referrer
      let domain = lastPage.split('/')[2]
      let noaccount = lastPage.split('/')[3] //排除account Url
      let domain_head = domain.split('.')[1].split('.')[0]
      let first_head = domain.split('.')[0]

      if (
        first_head == 'vtg' ||
        first_head == 'dtg' ||
        first_head == 'hanoiplas' ||
        first_head == 'vietnamprintpack' ||
        first_head == 'intelligentasia-thailand' ||
        first_head == 'vietnamplas' ||
        first_head == 'ipf' ||
        first_head == 'vietnamwood' ||
        first_head == 'automationtaipei' ||
        first_head == 'hanoiprintpack'
      ) {
        //改版官網存入sessionStorage的網址

        vm.lastUrl = vm.$cookies.get('RecordUrl')
      } else {
        if (lastPage && noaccount !== 'accounts') {
          if (domain == 'www.chanchao.com.tw' || domain_head == 'chanchao') {
            //如果網域為展昭

            vm.$cookies.set('url', lastPage, 60 * 60)
            vm.lastUrl = vm.$cookies.get('url')
          } else {
            vm.lastUrl = 'https://www.chanchao.com.tw/th' //如果不是展昭網域，就導回首頁
          }
        } else {
          if (vm.$cookies.get('url')) {
            vm.lastUrl = vm.$cookies.get('url')
          } else {
            vm.lastUrl = 'https://www.chanchao.com.tw/th'
          }
        }
      }

      //更換英文語系

      vm.$i18n.locale = 'th'
    },
  }
</script>

<style lang="scss">
  //Swal setting
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 12px;
  }

  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
  }

  .logoText {
    font-size: 20px;
  }

  .navLogo {
    height: 55px;
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .lineRight {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navText {
    display: flex;
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  @media (max-width: 768px) {
    .navLogo {
      height: 50px;
    }
    .lineRight {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
    }

    .navEnText {
      display: none;
    }

    .navText {
      display: block;
    }

    .logoText {
      font-size: 16px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
</style>
